import { Link } from 'react-router-dom';
import styled from 'styled-components';
const HomeShortcut = ({ url = "", title, icon }) => {
    return (
        <A to={url}>
            <img src={icon} alt="" />
            <span>{title}</span>
        </A>
    )
}
export default HomeShortcut;
const A = styled(Link)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.6rem;
    padding: 1.25rem 0.5rem;
    color: white;
    font-size: 0.95rem;
    font-weight: 600;
    text-align: center;
    transition: background-color 0.2s;
    & > img {
        width: 2rem;
        height: 2rem;
        object-fit: contain;
        opacity: 0.9;
        transition: transform 0.2s;
    }
    &:not(:last-child) {
        box-shadow: inset -1px 0 0 rgba(255, 255, 255, 0.1);
    }
    &:hover {
        background-color: rgba(255, 255, 255, 0.12);
        & > img {
            transform: translateY(-3px);
        }
    }
    @media (max-width: 991px) {
        padding: 1rem 0.25rem;
        font-size: 0.85rem;
        box-shadow: inset -1px -1px 0 rgba(255, 255, 255, 0.1);
        &:not(:last-child) {
            box-shadow: inset -1px -1px 0 rgba(255, 255, 255, 0.1);
        }
    }
`;
